const makeAllBoolInObjectFalse = (obj: { [key: string]: any }) => {
  const res = Object.keys(obj).reduce((acc: { [key: string]: any }, key) => {
    if (typeof obj[key] === "boolean") {
      acc[key] = false;
    } else {
      acc[key as string] = obj[key];
    }
    return acc;
  }, {});

  return res;
};

export default makeAllBoolInObjectFalse;
